import "./style.css";
import React from "react";
import { useContext, useState, useEffect } from "react";
import { BlockchainContext } from "../../context/BlockchainContext";
import ApeContractData from "../../blockchain/ApeContract";

function Rejectwallet() {
  const { mint, preSaleMint, IfWhitelisted, cost, totalSupply, phase, limit } =
    useContext(BlockchainContext);
  return (
    <div className="mainwelcome">
      <p className="nine">{totalSupply}/1000</p>

      <p className="welcometext44">Who sent you?</p>
    </div>
  );
}

export default Rejectwallet;
